import React from 'react';
import { DollarSignIcon, ScaleIcon, LineChartIcon, PackageIcon, FileTextIcon, WalletIcon } from 'lucide-react';
export function SolutionSection() {
  const modules = [{
    icon: DollarSignIcon,
    title: 'Daily P&L'
  }, {
    icon: ScaleIcon,
    title: 'Food Cost %'
  }, {
    icon: LineChartIcon,
    title: 'Labor Tracking'
  }, {
    icon: PackageIcon,
    title: 'Inventory Levels'
  }, {
    icon: FileTextIcon,
    title: 'Invoice Logging'
  }, {
    icon: WalletIcon,
    title: 'Net Cash Position'
  }];
  return <section className="bg-gray-50 px-6 py-16" data-id="element-43">
      <div className="max-w-2xl mx-auto" data-id="element-44">
        <div className="grid grid-cols-2 gap-4" data-id="element-45">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <div key={index} className="bg-white p-6 rounded-[8px] border border-gray-200 shadow-sm flex flex-col items-start gap-4" data-id="element-46">
                <Icon className="w-6 h-6 text-slate-navy" strokeWidth={1.5} data-id="element-47" />
                <h3 className="text-slate-navy font-manrope font-semibold text-sm" data-id="element-48">
                  {module.title}
                </h3>
              </div>;
        })}
        </div>
      </div>
    </section>;
}